import { useState } from 'react'
import { SignIn, SignUp, useUser, useClerk } from '@clerk/react'
import { useI18n } from '../stores/I18nContext'
import './Welcome.css'

export default function Welcome() {
  const [view, setView] = useState('welcome') // 'welcome', 'login', 'register'
  const { isSignedIn } = useUser()
  const { signOut } = useClerk()
  const { t } = useI18n()

  if (view === 'login') {
    return (
      <div className="welcome-container">
        <div className="welcome-content">
          <div className="welcome-header">
            <div className="logo-section">
              <img src="/teddo_the_icon_with_transparent.png" alt="TeDdO" className="welcome-logo" />
              <h1 className="welcome-title">
                Te<span className="highlight">Dd</span>O
              </h1>
            </div>
          </div>
          <div className="clerk-auth-container">
            <SignIn routing="hash" />
          </div>
          <button className="back-button" onClick={() => setView('welcome')}>
            {t('welcome.backToWelcome')}
          </button>
        </div>
      </div>
    )
  }

  if (view === 'register') {
    return (
      <div className="welcome-container">
        <div className="welcome-content">
          <div className="welcome-header">
            <div className="logo-section">
              <img src="/teddo_the_icon_with_transparent.png" alt="TeDdO" className="welcome-logo" />
              <h1 className="welcome-title">
                Te<span className="highlight">Dd</span>O
              </h1>
            </div>
          </div>
          <div className="clerk-auth-container">
            <SignUp routing="hash" />
          </div>
          <button className="back-button" onClick={() => setView('welcome')}>
            {t('welcome.backToWelcome')}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="welcome-header">
          <div className="logo-section">
            <img src="/teddo_the_icon_with_transparent.png" alt="TeDdO" className="welcome-logo" />
            <h1 className="welcome-title">
              Te<span className="highlight">Dd</span>O
            </h1>
          </div>
          <p className="welcome-subtitle">{t('app.title')}</p>
        </div>

        <div className="welcome-description">
          <p>{t('welcome.longDescription')}</p>
        </div>

        <div className="welcome-actions">
          {isSignedIn ? (
            <>
              <div className="auth-status-message">
                <p>{t('welcome.connectionLoading')}</p>
                <p>{t('welcome.connectionRetry')}</p>
              </div>
              <button className="btn-secondary btn-large" onClick={() => signOut()}>
                {t('welcome.signOut')}
              </button>
            </>
          ) : (
            <>
              <button className="btn-primary btn-large" onClick={() => setView('login')}>
                {t('welcome.signIn')}
              </button>
              <button className="btn-secondary btn-large" onClick={() => setView('register')}>
                {t('welcome.createAccount')}
              </button>
            </>
          )}
        </div>

        <div className="welcome-features">
          <h3>{t('welcome.featuresTitle')}</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h4>{t('welcome.features.multiFlowTitle')}</h4>
              <p>{t('welcome.features.multiFlowDescription')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔗</div>
              <h4>{t('welcome.features.dependenciesTitle')}</h4>
              <p>{t('welcome.features.dependenciesDescription')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h4>{t('welcome.features.progressTitle')}</h4>
              <p>{t('welcome.features.progressDescription')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💾</div>
              <h4>{t('welcome.features.cloudTitle')}</h4>
              <p>{t('welcome.features.cloudDescription')}</p>
            </div>
          </div>
        </div>

        <div className="welcome-examples">
          <h3>{t('welcome.examplesTitle')}</h3>
          <div className="examples-list">
            <div className="example-item">
              <strong>{t('welcome.examples.softwareTitle')}:</strong> {t('welcome.examples.softwareDescription')}
            </div>
            <div className="example-item">
              <strong>{t('welcome.examples.renovationTitle')}:</strong> {t('welcome.examples.renovationDescription')}
            </div>
            <div className="example-item">
              <strong>{t('welcome.examples.eventTitle')}:</strong> {t('welcome.examples.eventDescription')}
            </div>
            <div className="example-item">
              <strong>{t('welcome.examples.launchTitle')}:</strong> {t('welcome.examples.launchDescription')}
            </div>
          </div>
        </div>

        <div className="welcome-footer">
          <p>{t('welcome.footerPrompt')}</p>
          <button className="btn-primary" onClick={() => setView('register')}>
            {t('welcome.getStartedFree')}
          </button>
        </div>
      </div>
    </div>
  )
}
